// design pattern for aria-compliant radio group and radio
// https://www.w3.org/TR/2016/WD-wai-aria-practices-1.1-20160317/examples/radio/radio.html
import cx from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import './Radio.scss';

const Radio = (props) => {
  const {
    checked, children, className, onFocus, onKeyDown, value, variant,
  } = props;

  return (
    <div
      aria-checked={checked}
      className={cx('Radio', (variant && `Radio--${variant}`), className)}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      role="radio"
      tabIndex={checked ? 0 : -1}
      value={value}
    >
      {children}
    </div>
  );
};

Radio.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  className: PropTypes.string,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  checked: PropTypes.bool,
  value: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }).isRequired,
  variant: PropTypes.oneOf([null, 'input']),
};

Radio.defaultProps = {
  checked: false,
  className: null,
  onFocus: undefined,
  onKeyDown: undefined,
  variant: null,
};

Radio.displayName = 'Radio';
export default Radio;
